import { GridCell } from '@/models/bet/grid/cell';
import { memo } from 'react';
import TowerBoardCardIcon from './Icon';
import TowerRowCardImage from './Image';
import { TowerCardProps } from './props';

import { BetStatusId } from '@/models/bet/status/id';
import styles from './styles.module.scss';

function TowerCardComponent({
  position,
  bet,
  isBoletim,
  rowsCleared,
  onRowClick,
  isLoading,
  columns,
}: TowerCardProps): JSX.Element {
  function handleClickCard() {
    onRowClick(position);
  }

  //position + 1 to fix the reversed ui
  const row: number = Math.max(Math.ceil((position + 1) / columns)) - 1;

  const isSkull: boolean = bet
    ? bet?.status?.statusId?.toString() !== BetStatusId.Open?.toString()
      ? bet?.grid?.cells?.[position] == GridCell.Mine
      : bet?.grid?.clickedCells?.[position] == GridCell.Mine
    : false;
  const isPlaying: boolean = !!bet;
  const wasClicked = bet?.grid?.clickedCells?.[position] != GridCell.Empty;

  const isRevealed: boolean =
    (isPlaying && row < rowsCleared && wasClicked) ||
    (bet && bet?.status?.statusId?.toString() !== BetStatusId.Open?.toString());

  const isCardDisabled: boolean =
    isLoading || wasClicked || row != rowsCleared || !isPlaying || isBoletim;

  return (
    <div
      className={`${styles.card} ${isCardDisabled ? styles['card--disabled'] : ''}`}
      onClick={isBoletim ? () => undefined : handleClickCard}
    >
      <TowerBoardCardIcon
        disabled={isLoading || isRevealed}
        isPlaying={isPlaying}
        row={row}
        rowsCleared={rowsCleared}
        wasClicked={wasClicked}
        wasRevealed={isRevealed || isBoletim}
      />
      <TowerRowCardImage
        isRevealed={isRevealed || isBoletim}
        isSkull={isSkull}
        position={position}
        wasClicked={wasClicked}
        row={row}
        rowsCleared={rowsCleared}
      />
    </div>
  );
}

export default memo(TowerCardComponent);
